import { render, staticRenderFns } from "./TranslationsAddButtons.vue?vue&type=template&id=8e6a4ec8&"
import script from "./TranslationsAddButtons.vue?vue&type=script&lang=js&"
export * from "./TranslationsAddButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports